document.addEventListener("DOMContentLoaded", function() {

    // OPEN/CLOSE/CLONE MENU
    var btnMenu = document.querySelector('#mobile-toggle');
    var header = document.querySelector('.header');
    var body = document.body;

    // Clone main nav to use as mobile nav
    var clonedNav = header.cloneNode(true);
    clonedNav.classList.add("cloned-nav");

    // Remove btnMenu from cloned nav
    var clonedBtnMenu = clonedNav.querySelector('#mobile-toggle');
    if (clonedBtnMenu) clonedBtnMenu.remove();

    var mobileMenu = clonedNav.querySelector('#mobile-menu');
    // if (mobileMenu) mobileMenu.remove();

    // Remove header logo from cloned nav
    var clonedLogoHeader = clonedNav.querySelector('.main-nav_wrapper-logo-header');
    if (clonedLogoHeader) clonedLogoHeader.remove(); 

    // Add cloned nav to body
    body.appendChild(clonedNav);

    // Toggle menu mobile
    btnMenu.addEventListener('click', function(e) {
        e.preventDefault();
        clonedNav.classList.toggle("open");
        body.classList.toggle("no-scroll");
        btnMenu.classList.toggle('active');
        
    });

    // Close mobile menu when screen size is equal to lg
    window.addEventListener('resize', function() {
        if (window.innerWidth > 1023) {
            closeMobileMenu();
        }
    });

    // Close mobile menu when clicking a link
    clonedNav.addEventListener('click', function(e) {
        const link = e.target.closest('a');
        
        if (link && !link.classList.contains('menu-product-mobile-link')) {
            closeMobileMenu();
        }
    });

    // Function to close mobile menu
    function closeMobileMenu() {
        clonedNav.classList.remove('open');
        btnMenu.classList.remove('active');
        body.classList.remove('no-scroll');
        
        const submenus = clonedNav.querySelectorAll('.sub-menu');
        submenus.forEach(submenu => {
            submenu.classList.remove('open');
        });
    }

    // HANDLE MENU PRODUCT DETAIL DESKTOP
    const productLinks = document.querySelectorAll(".menu-product-link");
    const detailThumbnail = document.querySelector(".menu-product-detail-thumbnail");
    const detailDescription = document.querySelector(".menu-product-desktop-detail-description");
    const detailLink = document.querySelector(".menu-product-detail-wrapper");

    productLinks.forEach(link => {
        link.addEventListener("mouseenter", function (event) {
            event.preventDefault();

            const thumbnailUrl = this.getAttribute("data-thumbnail");
            const description = this.getAttribute("data-description");

            if (thumbnailUrl) {
                detailThumbnail.innerHTML = `${thumbnailUrl}`;
            }

            if (description) {
                detailDescription.textContent = description;
            }
        });
    });

    // // HANDLE MENU PRODUCT DETAIL MOBILE
    // if (window.innerWidth < 1024) {
        console.log("mobile");

        const mobileLinks = document.querySelectorAll(".cloned-nav .menu-product-mobile-link");
        const clonedNavDescription = document.querySelector(".cloned-nav .menu-product-mobile-detail-description");
        const mobileDetailLink = document.querySelector(".cloned-nav .menu-product-mobile-detail-button");

        function updateDetails(link) {
            const descriptionMobile = link.getAttribute("data-description-mobile");
            const linkUrl = link.getAttribute("data-product-link-mobile");
            const postTitle = link.getAttribute("data-post-title");
            const translation = link.getAttribute("data-translation");

            if (clonedNavDescription) {
                clonedNavDescription.innerHTML = `<p>${descriptionMobile}</p>`;
            }

            if (mobileDetailLink) {
                mobileDetailLink.setAttribute("href", linkUrl);
                mobileDetailLink.innerHTML = `${postTitle} ${translation} <div class="icon-plus">${document.querySelector(".icon-plus").innerHTML}</div>`;
            }
        }

        const productList = document.querySelectorAll('.menu-products-mobile-list')[1];

        let isScrolling;
        productList.addEventListener('scroll', () => {
            const viewportCenter = window.innerWidth / 2;
            let closestElement = null;
            let lowestDistance = 99999999;
            mobileLinks.forEach((link) => {
                const rect = link.getBoundingClientRect();  
                const elementCenterX = rect.x + (rect.width / 2);
                const distanceToCenter = Math.abs(elementCenterX - viewportCenter);

                if (distanceToCenter < lowestDistance) {
                    lowestDistance = distanceToCenter
                    closestElement = link;
                }
            });
            updateDetails(closestElement);
        }, 100);
    // }
});